import { Input } from "@equidefi/ui/forms";
import type { InputProps } from "@equidefi/ui/forms/Input";
import type { FieldPath, FieldValues } from "react-hook-form";
import { useController, useFormContext } from "react-hook-form";

export type SmartInputProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = Omit<InputProps, "name" | "label" | "helperText" | "isRequired" | "error" | "isInvalid"> & {
  name: TName;
  label?: string;
  helperText?: string;
  isRequired?: boolean;
};

function SmartInput<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({ name, label, helperText, isRequired, ...inputProps }: SmartInputProps<TFieldValues, TName>) {
  const { control } = useFormContext<TFieldValues>();
  const {
    field,
    fieldState: { error },
  } = useController<TFieldValues, TName>({
    name,
    control,
  });

  return (
    <Input
      {...field}
      label={label as string}
      isInvalid={!!error}
      isRequired={isRequired}
      helperText={helperText}
      error={error?.message}
      {...inputProps}
    />
  );
}

export default SmartInput;
